import Axios from "axios";

const URL_AUTH = import.meta.env.VITE_AUTH_URL;

export function PersonTypeListService() {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await Axios.get(
        `${URL_AUTH}/api/agent/v1/info/person-type`,
        {
          headers: {
            "X-localization": `${window.localStorage.getItem("i18nextLng")}`,
          },
        }
      );
      resolve(response.data);
    } catch (error) {
      reject(error);
    }
  });
}